import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import Typography from './Typography';
import Button from './Button';
import ModalHeader from '../header/ModalHeader';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getCancelDialogConfig } from '../../common/Util';

const slideRight = keyframes`
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
`;

const slideLeft = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  // box-shadow: inset 0 0 0 1000px rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const DialogContainer = styled.div.withConfig({
  shouldForwardProp: prop => !['isClosing'].includes(prop),
})`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  height: 100vh; // 명시적 높이 설정
  background-color: white;
  animation: ${({ isClosing }) => (isClosing ? slideLeft : slideRight)} 0.3s ease-out;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.3);
  z-index: 1001;

  // 모바일 Safari를 위한 추가 설정
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
`;

const Content = styled.div`
  margin-top: 64px; /* 헤더 높이만큼 여백 추가 */
  padding: 30px 16px 64px 16px;
  // padding-bottom: 200px;
  height: calc(100% - 64px); /* 헤더 높이를 제외한 높이 */
  overflow-y: auto;

  /* 스크롤바 숨기기 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 및 Edge */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }
`;

const SlideRightDialog = ({ isOpen, onClose, children, title, contentStyle }) => {
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);
  const { t } = useTranslation('common');
  const { isDataModified } = useSelector(state => state.common);

  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setIsClosing(false);
    } else if (visible) {
      setIsClosing(true);
      const timer = setTimeout(() => {
        setVisible(false);
      }, 200); // 애니메이션 지속 시간과 일치해야 함
      return () => clearTimeout(timer);
    }
  }, [isOpen, visible]);

  const handleCancel = () => {
    console.log('isDataModified >>', isDataModified);
    if (isDataModified) {
      //입력된 내용이 저장되지 않았~ 취소하시겠~~?
      dispatch(getCancelDialogConfig(t, 'notSaved'));
    } else {
      if (onClose) {
        onClose();
      }
    }
  };

  if (!visible) return null;

  return (
    <>
      <Overlay onClick={handleCancel} />
      <DialogContainer isClosing={isClosing}>
        <ModalHeader title={title || t('header.title4')} onClose={handleCancel} />
        <Content style={contentStyle}>{children}</Content>
      </DialogContainer>
    </>
  );
};

export default SlideRightDialog;
